<template>
  <div>
    <v-list-item
      fluid
      inset
    >
      <v-list-item-content>
        <v-list-item-title
          style="font-weight: bold;"
        >
          <!-- {{ question?.id }}. {{ question?.name }} -->
          <v-row>
            <v-col
              style="max-width: 50px;text-align: right;"
            >
              {{ question?.id }}.
            </v-col>
            <v-col cols="auto">
              {{ question?.name }}
              <!-- ({{ question?.ratio }}) -->
            </v-col>
          </v-row>
        </v-list-item-title>
        <v-row>
          <v-col
            style="max-width: 50px;text-align: right;"
            class="py-0"
          />
          <v-col
            cols="auto"
            class="py-0"
          >
            <v-radio-group
              class="mt-0"
              v-if="question?.type === 'radio'"
              v-model="answer"
              hide-details
            >
              <v-radio
                v-for="(option, key) in question.options"
                :key="key"
                :label="option.name"
                :value="option.id"
              />
            </v-radio-group>
            <v-select
              class="pt-0"
              style="min-width: 300px;"
              v-else-if="question?.type === 'select'"
              v-model="answer"
              :items="question.options"
              item-text="name"
              item-value="id"
              hide-details
            />
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
    <!-- <v-divider /> -->
  </div>
</template>

<script>

export default {
  props: {
    question: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      answer: null
    }
  },
  computed: {
    score () {
      return (this.question?.options.find(option => option.id === this.answer)?.score || 0)
    }
  },
  watch: {
    answer () {
      this.updateScore()
    },
    question () {
      this.answer = null
      this.updateScore()
    }
  },
  methods: {
    getQuestionScore () {
      const ratio = this.question.ratio / 100
      return {
        question: this.question,
        score_scaled: this.score * ratio,
        max_score_scaled: Math.max(...this.question.options.map(option => option.score)) * ratio,
        min_score_scaled: Math.min(...this.question.options.map(option => option.score)) * ratio,
        answer: this.answer
      }
    },
    updateScore () {
      const newScore = this.getQuestionScore()
      this.$emit('onScoreUpdate', newScore)
    }
  },
  mounted () {
    this.$nextTick(() => {
      // initial score update for max and min
      this.updateScore()
    })
  }
}
</script>
